const WD = ["Po", "Ut", "St", "Št", "Pi", "So", "Ne"];

export function AttendanceCalendar({ month, daily, today, selected, onSelect, testId = "attendance-calendar", dayPrefix = "attendance-cal-day" }) {
  const [y, m] = month.split("-").map(Number);
  const byDate = {};
  (daily || []).forEach((d) => { byDate[d.date] = d; });
  const firstDow = (new Date(y, m - 1, 1).getDay() + 6) % 7;
  const days = new Date(y, m, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  return (
    <div data-testid={testId}>
      <div className="mb-1 grid grid-cols-7 gap-1 text-center text-[10px] font-semibold uppercase text-muted-foreground">
        {WD.map((w) => <div key={w}>{w}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (!d) return <div key={i} />;
          const ds = `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
          const rec = byDate[ds];
          const isToday = ds === today;
          const miss = rec && rec.missing_out > 0;
          const has = rec && rec.records?.length > 0;
          const isSel = ds === selected;
          return (
            <button key={i} type="button" onClick={() => has && onSelect(isSel ? null : ds)} disabled={!has}
              data-testid={`${dayPrefix}-${ds}`}
              className={`flex aspect-square flex-col items-center justify-center rounded-md border transition-colors
                ${miss ? "border-amber-500/60 bg-amber-500/15" : has ? "border-border bg-background/60" : "border-transparent bg-background/20"}
                ${isToday ? "ring-2 ring-primary" : ""} ${isSel ? "border-primary" : ""}
                ${has ? "cursor-pointer hover:border-primary/70" : "cursor-default opacity-50"}`}>
              <span className={`text-[11px] font-semibold ${miss ? "text-amber-400" : "text-foreground"}`}>{d}</span>
              {has && <span className={`font-mono text-[10px] leading-tight ${miss ? "text-amber-400" : "text-primary"}`}>{rec.hours} h</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
